import { render, staticRenderFns } from "./invoiceServe.vue?vue&type=template&id=52cb14f6&scoped=true"
import script from "./invoiceServe.vue?vue&type=script&lang=js"
export * from "./invoiceServe.vue?vue&type=script&lang=js"
import style0 from "./invoiceServe.vue?vue&type=style&index=0&id=52cb14f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb14f6",
  null
  
)

export default component.exports